
import { Vue, Component } from "vue-property-decorator";
import { getEmployeesTargetActions } from "@/api/offers";
import AdministrationOffersLayout from "@/components/layout/AdministrationOffersLayout.vue";

@Component({
    methods: { getEmployeesTargetActions },
    components: { AdministrationOffersLayout },
})

export default class TargetActions extends Vue {}
